import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a28392c0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/warningcenter.less?vue&type=style&index=0&id=a28392c0&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=a28392c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28392c0",
  null
  
)

export default component.exports